@use '@/styles/tokens' as *;

/** Fieldset wrapper for the date range. Mirrors FormField's vertical rhythm + label look so it
 *  lines up with the MultiSelectFields. */
.fieldset {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  margin: 0 0 var(--space-4);
  padding: 0;
  border: 0;
}

.legend {
  padding: 0 var(--space-2);
  font-size: $font-size-md;
  font-weight: var(--font-weight-regular);
  color: var(--text-secondary);
}
